import { Auth } from '@nackle/bridge';
import { AUTH_ENDPOINT } from './endpoints';

export const authSettings = new Auth( {
    authority: AUTH_ENDPOINT,
    debug: false
} );

export let accessToken = '';
export let company_UUID = '';
export let person_Id = '';

authSettings.events.stateChange.on( ( authState ) => {
    accessToken = authState.access_token;
    company_UUID = authState.claims.company_id;
    person_Id = authState.claims.person_id;
} );

authSettings.events.signIn.on( ( authState ) => {
    accessToken = authState.access_token;
    company_UUID = authState.claims.company_id;
    person_Id = authState.claims.person_id;
} );

export const handleSignOut = () => { 
    authSettings.signOut();
};
